import './style.scss';

'use strict';

document.addEventListener( 'DOMContentLoaded', function() {

	// if ( typeof window.acf === 'undefined'){
	// 	console.error('The Advanced Custom Fields plugin is not enabled. Some blocks will not work.')
	// }

	var sliders = document.querySelectorAll( '.block-slider' );

	if ( sliders.length === 0 ) {
		return;
	}

	( function() {
		const initSliders = () => {
			const defaultSettings = {
				pagination: false,
				loop: false,
				rewind: false,
				simulateTouch: true,
				slidesPerView: 2,
			};

			const breakpoints = {
				md: 768,
				lg: 1024
			};

			sliders.forEach( ( el, i ) => {
				if ( typeof Swiper === 'undefined' || !el.querySelector( '.swiper' ) ) {
					console.log( 'found no slider cards' );
					return;
				}

				const swiperSlider = el.querySelector( '.swiper' );
				swiperSlider.classList.add( `swiper-${i}` );

				const nextEl = el.querySelector( '.swiper-button-next' );
				const prevEl = el.querySelector( '.swiper-button-prev' );

				nextEl.classList.add( `swiper-button-next-${i}` );
				prevEl.classList.add( `swiper-button-prev-${i}` );

				document.querySelectorAll( '.swiper-wrapper > div' ).forEach( div => div.classList.add( 'swiper-slide' ) );

				let customSettings = {};

				// Navigation settings
				setProperty( customSettings, 'navigation.nextEl', `.swiper-button-next-${i}` );
				setProperty( customSettings, 'navigation.prevEl', `.swiper-button-prev-${i}` );

				// Slides per view settings
				const dataItems = JSON.parse( el.dataset.swiperItems );
				if ( dataItems ) {
					if ( dataItems.sm ) {
						setProperty( customSettings, 'slidesPerView', dataItems.sm );
					}
					if ( dataItems.md ) {
						setProperty( customSettings, `breakpoints.${breakpoints.md}.slidesPerView`, dataItems.md );
					}
					if ( dataItems.lg ) {
						setProperty( customSettings, `breakpoints.${breakpoints.lg}.slidesPerView`, dataItems.lg );
					}
				}

				// Gutter settings
				const dataGutter = JSON.parse( el.dataset.swiperGutter );
				if ( dataGutter ) {
					if ( dataGutter.sm ) {
						setProperty( customSettings, 'spaceBetween', dataGutter.sm );
					}
					if ( dataGutter.md ) {
						setProperty( customSettings, `breakpoints.${breakpoints.md}.spaceBetween`, dataGutter.md );
					}
					if ( dataGutter.lg ) {
						setProperty( customSettings, `breakpoints.${breakpoints.lg}.spaceBetween`, dataGutter.lg );
					}
				}

				if ( window.innerWidth >= breakpoints.md || el.querySelector( '.is-not-stacked-on-mobile' ) ) {
					const swiper = new Swiper( `.swiper-${i}`, {
						...defaultSettings,
						...customSettings
					} );
				}
			} );
		};

		const setProperty = ( obj, path, value ) => {
			var schema = obj;
			var pList = path.split( '.' );
			var len = pList.length;
			for ( var i = 0; i < len - 1; i ++ ) {
				var elem = pList[ i ];
				if ( !schema[ elem ] ) schema[ elem ] = {};
				schema = schema[ elem ];
			}

			schema[ pList[ len - 1 ] ] = value;
		};

		if ( typeof Swiper === 'undefined' ) {
			// Load Swiper script and styles dynamically
			var scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
			var styleUrl = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';

			var link = document.createElement( 'link' );
			link.rel = 'stylesheet';
			link.type = 'text/css';
			link.href = styleUrl;
			document.head.appendChild( link );

			var script = document.createElement( 'script' );
			script.src = scriptUrl;
			script.onload = initSliders;
			document.head.appendChild( script );
		} else {
			initSliders();
		}

	} )();
} );
